"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** TagIcon */
var TagIcon = function TagIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Page" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M6.00044479,4.93806303 L6.00044479,15.4143978 L12.0004448,15.4143978 L12.0004448,4.92560152 L9.07178514,2.80969827 L6.00044479,4.93806303 Z M5.00044479,4.4143978 L9.08382677,1.58471261 L13.0004448,4.4143978 L13.0004448,16.4143978 L5.00044479,16.4143978 L5.00044479,4.4143978 Z",
    transform: "translate(9.000445, 8.999555) rotate(-315.000000) translate(-9.000445, -8.999555)",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Circle, {
    cx: "11.5",
    cy: "6.5",
    r: "1",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.TagIcon = TagIcon;
TagIcon.displayName = "TagIcon";
//# sourceMappingURL=TagIcon.js.map